import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'hour' })
export class HourPipe implements PipeTransform {
  transform(value: number): string {
    return value.toString().padStart(2, '0');
  }
}
